import { IdpRole } from './constant';

import { UserRoles } from './beans/index';
import { DateTime } from 'luxon';

export const parseJwt = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );
  return JSON.parse(jsonPayload);
};

export const userIsSchoolTeacher = (roles: Array<UserRoles>): boolean => roles.some(r => r.roleName === IdpRole.MYZ_DOCENTE);

export const isValidDate = (dateOfStart: string, dateOfEnd: string) => {
  const currentDate = DateTime.now();
  const startDate = DateTime.fromFormat(dateOfStart, 'dd/MM/yyyy');
  const endDate = DateTime.fromFormat(dateOfEnd, 'dd/MM/yyyy');

  return currentDate >= startDate && currentDate <= endDate;
};
